var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-mob",on:{"click":_vm.gotoApp}},[_c('img',{staticClass:"button-img",attrs:{"src":require("../assets/images/2025/button-img.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }